import React from 'react'
import { useMutation } from 'react-query'
import { Deal } from 'scenes/Dashboard/data/deals/types'
import { QueryStatus } from 'utils-next/api'
import { ExtendableStyles } from 'utils-next/types'

import { FormControlLabel, Switch } from '@mui/material'

import { useDealHandlers } from './DealCard.container'

export type DealRelaxedSweetSpotProps = ExtendableStyles & {
  deal: Deal
}

export function DealRelaxedSweetSpot({ deal, ...otherProps }: DealRelaxedSweetSpotProps) {
  const { updateDealSweetSpot } = useDealRelaxedSweetSpotHandlers(deal)
  const { status, mutate: handleChange } = useMutation(updateDealSweetSpot)

  return (
    <FormControlLabel
      control={<Switch checked={deal.fitsWithRelaxedCriteria} onChange={(_, checked) => handleChange(checked)} />}
      label="Relaxed sweet spot"
      disabled={status === QueryStatus.loading}
      {...otherProps}
    />
  )
}

function useDealRelaxedSweetSpotHandlers(deal: Deal) {
  const { updateDealData } = useDealHandlers(deal.id)
  const updateDealSweetSpot = (checked: boolean) => updateDealData({ ...deal, fitsWithRelaxedCriteria: checked })
  return {
    updateDealSweetSpot,
  }
}
